module.exports = __webpack_public_path__ + "img/paas_02.ad832a34.svg";